<template>
  <div class="space-y-6">
    <UCard
      v-for="i in 2"
      :key="i"
      :ui="{ rounded: 'rounded-none md:rounded-lg' }"
    >
      <div class="space-y-6">
        <!-- Satıcı başlığı skeleton -->
        <div class="flex items-center justify-between pb-4 border-b">
          <div class="flex items-center space-x-2">
            <USkeleton class="w-4 h-4" />
            <USkeleton class="h-4 w-32" />
          </div>
          <USkeleton class="h-8 w-24" />
        </div>

        <!-- Ürün skeleton -->
        <div class="divide-y divide-slate-100">
          <div v-for="j in 2" :key="j" class="py-4">
            <div class="flex space-x-4">
              <USkeleton class="w-20 h-20 rounded-lg" />
              <div class="flex-1 space-y-2">
                <USkeleton class="h-4 w-3/4" />
                <USkeleton class="h-4 w-1/2" />
                <div class="flex justify-between items-center mt-4">
                  <USkeleton class="h-4 w-24" />
                  <div class="flex items-center space-x-2">
                    <USkeleton class="h-8 w-24" />
                    <USkeleton class="h-8 w-8" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UCard>
  </div>
</template>
